module.exports = __webpack_public_path__ + "img/161-balearic islands.432973f2.svg";